// extracted by mini-css-extract-plugin
export default {"container":"container-MY5vo","static":"static-Artgs","active":"active-Iu43a"};